import { useWorkflowStatus } from './WorkflowStatusProvider'
import { WorkflowStatusSelect } from './WorkflowStatusSelect'

interface Props {
  size?: 'sm' | 'md'
}

export const WorkflowStatus = ({ size = 'md' }: Props) => {
  const { currentState } = useWorkflowStatus()

  if (!currentState?.propertyValue) {
    return null
  }

  return <WorkflowStatusSelect size={size} />
}
